import * as a from "@sentry/react";
import { reactErrorHandler as p, ErrorBoundary as h } from "@sentry/react";
import { ErrorBoundary as K, addBreadcrumb as X, captureConsoleIntegration as Q, captureException as Y, captureMessage as Z, extraErrorDataIntegration as J, isInitialized as ee, reactErrorHandler as re, reactRouterV7BrowserTracingIntegration as te, setContext as ne, setTag as oe, setUser as ie, tanstackRouterBrowserTracingIntegration as ae, withScope as se, wrapCreateBrowserRouterV7 as ce } from "@sentry/react";
import { jsx as y } from "react/jsx-runtime";
function T() {
  if (typeof document > "u") return "development";
  const e = document.location.host;
  return e === "tripletex.no" ? "production" : e.endsWith("tripletex.dev") ? "sandbox" : "development";
}
const d = T(), E = d === "production", V = d === "sandbox", R = "https://468abff9a93c1c808ae92d7efa4adb0c@o4510231998955520.ingest.de.sentry.io/4511022112178256";
function m() {
  return new URLSearchParams(window.location.search).get("contextId");
}
function I(e, t) {
  const r = t?.originalException;
  return r instanceof Error && "details" in r && typeof r.details == "object" && r.details !== null ? {
    ...e,
    extra: { ...e.extra, ...r.details }
  } : e;
}
function P(e, t) {
  const r = t?.originalException;
  return r instanceof DOMException && r.name === "AbortError" ? null : e;
}
const A = [
  /Failed to fetch/,
  /Load failed/,
  /CSRF token cookie/,
  /SessionPlugin: Missing startAt/,
  /initEternlDomAPI/,
  /\[PaymentAPI\]/
];
function b(e) {
  if (e.type !== void 0) {
    const t = e.message || "";
    if (A.some((r) => r.test(t)))
      return null;
  }
  return e;
}
const g = [
  "TlxBadRequest-",
  // 400 — malformed request
  "TlxForbiddenErrorCode-",
  // 403 — permission denied
  "TlxNotFoundErrorCode-",
  // 404 — entity not found
  "TlxConflictError-",
  // 409 — optimistic lock / duplicate / locked
  "TlxValidationError-"
  // 422 — backend validation failure
];
function w(e) {
  return e instanceof Error && g.some((t) => e.name.startsWith(t));
}
function C(e, t) {
  const r = t?.originalException;
  if (w(r))
    return null;
  const n = e.exception?.values;
  if (n) {
    for (const o of n)
      if (o.type && g.some((s) => o.type?.startsWith(s)))
        return null;
  }
  return e;
}
const l = "Failed to fetch dynamically imported module";
function D(e, t) {
  const r = t?.originalException;
  if (r instanceof Error && r.message.includes(l) || typeof r == "string" && r.includes(l))
    return null;
  const n = e.exception?.values;
  if (n) {
    for (const o of n)
      if (o.value?.includes(l))
        return null;
  }
  return e.message?.includes(l) ? null : e;
}
const k = [
  "Failed to fetch",
  "NetworkError when attempting to fetch resource.",
  "The Internet connection appears to be offline.",
  "Load failed"
];
function f(e) {
  return k.some(
    (t) => e === t || e.includes(t)
  );
}
function U(e, t) {
  const r = t?.originalException;
  if (r instanceof Error && r.name === "TypeError" && (f(r.message) || !navigator.onLine) || typeof r == "string" && f(r))
    return null;
  const n = e.exception?.values;
  if (n) {
    for (const o of n)
      if (o.value && f(o.value))
        return null;
  }
  return e;
}
const u = "ResizeObserver loop";
function z(e, t) {
  const r = t?.originalException;
  if (r instanceof Error && r.message.includes(u) || typeof r == "string" && r.includes(u))
    return null;
  const n = e.exception?.values;
  if (n) {
    for (const o of n)
      if (o.value?.includes(u))
        return null;
  }
  return e.message?.includes(u) ? null : e;
}
function v(e) {
  return e instanceof Error && "details" in e && typeof e.details?.status == "number" && typeof e.details?.code == "number";
}
function N(e) {
  return e instanceof Error && e.name.startsWith("TlxUnauthorized-");
}
function B(e, t) {
  const r = t?.originalException;
  if (v(r) && r.details.status === 401 && r.details.code === 3e3 || N(r))
    return null;
  const n = e.exception?.values;
  if (n) {
    for (const o of n)
      if (o.type?.startsWith("TlxUnauthorized-"))
        return null;
  }
  return e;
}
const _ = {
  "project-shared": "SHEET_STORM"
}, O = ["project-shared", "atlas", "astro-shared", "intl", "sentry"];
function W(e) {
  const t = e.exception?.values?.flatMap((r) => r.stacktrace?.frames ?? []);
  if (!t || t.length === 0)
    return e;
  for (const r of t) {
    const n = r.filename ?? "";
    for (const o of O)
      if (n.includes(`packages/${o}/`) || n.includes(`@tlx/${o}/`)) {
        const s = _[o];
        return e.tags = {
          ...e.tags,
          shared_package: o,
          ...s && { shared_package_team: s }
        }, e;
      }
  }
  return e;
}
function L(e) {
  if (a.isInitialized()) return;
  const {
    appName: t,
    team: r,
    eventProcessors: n = [],
    release: o,
    ignoreErrors: s = [],
    denyUrls: x = [],
    ...c
  } = e, i = a.init({
    // Shared defaults (can be overridden by spreading options)
    dsn: R,
    environment: d,
    // Strip release in development to avoid creating ghost releases in Sentry
    release: d === "development" ? void 0 : o,
    sampleRate: 1,
    tracesSampleRate: E ? 0.1 : 1,
    replaysOnErrorSampleRate: 1,
    enabled: E,
    initialScope: {
      tags: {
        appName: t,
        contextId: m()
      }
    },
    // App-specific overrides
    ...c,
    // Merge integrations: shared defaults + user-provided
    integrations: [
      a.browserTracingIntegration(),
      a.breadcrumbsIntegration({
        dom: {
          serializeAttribute: ["data-testid", "data-trackingid"]
        }
      }),
      ...Array.isArray(c.integrations) ? c.integrations : []
    ],
    // Merge noise filters: shared defaults + app-specific additions (after ...options spread to win)
    ignoreErrors: [
      /Request timeout/,
      /React was able to recover by instead synchronously rendering/,
      /Importing a module script failed/,
      // Dynamic import failures after deploy (stale tabs)
      /Failed to fetch dynamically imported module/,
      /error loading dynamically imported module/,
      // Console.info logging from payment callback captured as errors
      /AppCallbackWrapper/,
      /AppApprovalWrapper/,
      // Browser extension / crypto wallet noise injected into page context
      /EthereumProvider/,
      /TronLink/,
      /Provider initialised/,
      // Belt-and-suspenders for 401s that slip past filterExpiredSessions
      /TlxUnauthorized/,
      // Belt-and-suspenders for expected API errors that slip past filterExpectedAPIErrors
      // (e.g. captureConsole message events that processors never see)
      /TlxBadRequest/,
      /TlxForbiddenErrorCode/,
      /TlxNotFoundErrorCode/,
      /TlxConflictError/,
      /TlxValidationError/,
      // Non-actionable browser/library warnings
      /SessionPlugin: Missing startAt/,
      /Tour .+ already running/,
      /Performance measurement service/,
      /history\.replaceState/,
      /focus-fighting detected/,
      // Network errors that bypass filterOfflineErrors via captureConsoleIntegration
      // (captureConsole creates message events, not exception events — processors never see them)
      /Failed to fetch/,
      /Load failed/,
      /NetworkError when attempting to fetch/,
      /network error/i,
      // Expired session (CSRF cookie gone after session timeout)
      /CSRF token cookie/,
      // Browser extensions mutating DOM — React reconciler race condition
      /removeChild.*Node/,
      // Anonymous errors with no stack trace — completely unactionable
      /^<unknown>$/,
      // Transient backend overload
      /Service unavailable/,
      // Cross-origin iframe print blocked by browser security
      /Blocked a frame with origin/,
      /\[PaymentAPI\]/,
      // Payment callback console logs
      /initEternlDomAPI/,
      // 3rd party DOM mutation library
      /QuotaExceededError/,
      // localStorage full — user's browser, not our bug
      /sendWithPromise/,
      // Legacy bridge method, not actionable
      /TourMe could not find/,
      // Tour guide element missing, cosmetic only
      /StreamMiddleware.*Unknown/,
      // Stream response ID mismatch, transient
      /Context ID param.*not found/,
      // URL param race condition
      ...s
    ],
    denyUrls: [/^chrome-extension:\/\//, /^moz-extension:\/\//, /^safari-extension:\/\//, ...x],
    // Deep merge initialScope.tags so contextId and appName aren't lost
    ...c.initialScope && {
      initialScope: {
        ...c.initialScope,
        tags: {
          appName: t,
          contextId: m(),
          ...c.initialScope?.tags
        }
      }
    }
  });
  if (r && a.setTag("team", r), i && (i.addEventProcessor(P), i.addEventProcessor(C), i.addEventProcessor(b), i.addEventProcessor(I)), i && n.length > 0)
    for (const S of n)
      i.addEventProcessor(S);
}
function G() {
  return {
    onUncaughtError: p(),
    // onCaughtError is intentionally omitted — errors caught by ErrorBoundary
    // are reported by the boundary itself (with team/feature scope tags).
    // Including it here would cause duplicate reports without scope overrides.
    onRecoverableError: p()
  };
}
function j({ team: e, fallback: t, children: r }) {
  return /* @__PURE__ */ y(
    h,
    {
      fallback: t,
      beforeCapture: (n) => {
        n.setTag("team", e);
      },
      children: r
    }
  );
}
function H(e, t) {
  a.withScope((r) => {
    r.setTag("team", t), a.captureException(e);
  });
}
export {
  K as ErrorBoundary,
  R as SENTRY_DSN_FRONTEND,
  j as SentryTeamScope,
  X as addBreadcrumb,
  Q as captureConsoleIntegration,
  Y as captureException,
  H as captureExceptionWithTeam,
  Z as captureMessage,
  I as enrichApiErrors,
  J as extraErrorDataIntegration,
  B as filterExpiredSessions,
  D as filterMissingDynamicModules,
  U as filterOfflineErrors,
  z as filterResizeObserverErrors,
  m as getContextId,
  L as initSentry,
  ee as isInitialized,
  E as isProduction,
  V as isSandbox,
  re as reactErrorHandler,
  te as reactRouterV7BrowserTracingIntegration,
  G as sentryCreateRootOptions,
  d as sentryEnvironment,
  ne as setContext,
  oe as setTag,
  ie as setUser,
  W as tagSharedPackage,
  ae as tanstackRouterBrowserTracingIntegration,
  se as withScope,
  ce as wrapCreateBrowserRouterV7
};
//# sourceMappingURL=sentry.es.js.map
